<template>
  <div id="catalog" class="section_catalog">
    <p class="title_bid_form">
      КАТАЛОГ <span class="color_orange">МЕБЕЛИ</span>
    </p>
    <div class="catalog">
      <nav>
        <ul class="nav_catalog">
          <li
            v-for="key in categoryKeys"
            :key="key"
            class="li_button"
            :class="{ active: selectedCategory === key }"
            @click="selectCategory(key)"
          >
            {{ categories[key].name }}
          </li>
        </ul>
      </nav>

      <div class="content">
        <div class="image-container">
          <div class="slider-frame">
            <img
              :src="currentImage"
              :alt="categories[selectedCategory].name"
              class="category-image"
            />

            <button
              v-if="hasMultipleSlides"
              type="button"
              class="slider-arrow slider-arrow_prev"
              aria-label="Предыдущее фото"
              @click="prevSlide"
            >
              <svg
                class="slider-arrow-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M14.5 5.5L8 12l6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.4"
                />
              </svg>
            </button>
            <button
              v-if="hasMultipleSlides"
              type="button"
              class="slider-arrow slider-arrow_next"
              aria-label="Следующее фото"
              @click="nextSlide"
            >
              <svg
                class="slider-arrow-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M9.5 5.5L16 12l-6.5 6.5"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.4"
                />
              </svg>
            </button>
          </div>

          <div v-if="hasMultipleSlides" class="slider-footer">
            <div class="slider-dots">
              <button
                v-for="(image, index) in currentCategory.images"
                :key="`${selectedCategory}-${index}`"
                type="button"
                class="slider-dot"
                :class="{ active: currentSlide === index }"
                :aria-label="`Фото ${index + 1}`"
                @click="goToSlide(index)"
              ></button>
            </div>
            <p class="slider-counter">
              {{ String(currentSlide + 1).padStart(2, "0") }} /
              {{ String(currentCategory.images.length).padStart(2, "0") }}
            </p>
          </div>
        </div>

        <div class="description">
          <h2 class="title_catalog" v-html="currentCategory.title"></h2>
          <p
            class="selectedCategory_catalog"
            v-html="currentCategory.description"
          ></p>
          <div
            v-if="currentCategory.htmlDescription"
            class="sub_text_catalog"
            v-html="currentCategory.htmlDescription"
          ></div>
          <div class="box_button_catalog">
            <button class="button_catalog" @click="toggleCart">
              <span>ПОДРОБНЕЕ</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useCartStore } from "@/store/cartStore";
import kitchen from "@/assets/img/catalog/kitchen.webp";
import kitchen2 from "@/assets/img/catalog/kitchen2.png";
import kitchen3 from "@/assets/img/catalog/kitchen3.webp";
import wardrobe from "@/assets/img/catalog/Wardrobe.jpg";
import wardrobe2 from "@/assets/img/catalog/Wardrobe2.png";
import wardrobeAlt from "@/assets/img/catalog/Wardrobe.webp";
import cabinets from "@/assets/img/catalog/cabinets.webp";
import cabinets2 from "@/assets/img/catalog/cabinets2.webp";
import cabinets3 from "@/assets/img/catalog/cabinets3.webp";
import hallways from "@/assets/img/catalog/Hallway.webp";
import hallways2 from "@/assets/img/catalog/hallways2.png";
import hallways3 from "@/assets/img/catalog/Hallway3.webp";

import forBusiness from "@/assets/img/catalog/for_business.webp";
import forBusiness2 from "@/assets/img/catalog/forBusiness2.webp";
import forBusiness3 from "@/assets/img/catalog/forBusiness3.webp";

const cartStore = useCartStore();
const toggleCart = cartStore.toggleCart;

const categories = {
  kitchens: {
    name: "Кухни",
    title: "Мебель для <span class='color_orange'>кухни</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    images: [kitchen, kitchen2, kitchen3],
  },
  wardrobe: {
    name: "Гардероб",
    title: "Мебель для <span class='color_orange'>гардероба</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    images: [wardrobeAlt, wardrobe, wardrobe2],
  },
  cabinets: {
    name: "Шкафы",
    title: "<span class='color_orange'>Шкафы</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    images: [cabinets, cabinets2,cabinets3],
  },
  hallways: {
    name: "Прихожие",
    title: "Мебель для <span class='color_orange'>прихожей</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    images: [hallways3, hallways, hallways2],
  },
  for_business: {
    name: "Для бизнеса",
    title: "Мебель для <span class='color_orange'>офисов</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    images: [forBusiness2, forBusiness, forBusiness3],
  },
};

const categoryKeys = Object.keys(categories);
const selectedCategory = ref("kitchens");
const currentSlide = ref(0);

const currentCategory = computed(() => categories[selectedCategory.value]);
const currentImage = computed(
  () =>
    currentCategory.value.images[currentSlide.value] ||
    currentCategory.value.images[0]
);
const hasMultipleSlides = computed(
  () => currentCategory.value.images.length > 1
);

const nextSlide = () => {
  if (!hasMultipleSlides.value) {
    return;
  }

  currentSlide.value =
    (currentSlide.value + 1) % currentCategory.value.images.length;
};

const prevSlide = () => {
  if (!hasMultipleSlides.value) {
    return;
  }

  currentSlide.value =
    (currentSlide.value - 1 + currentCategory.value.images.length) %
    currentCategory.value.images.length;
};

const goToSlide = (index) => {
  currentSlide.value = index;
};

const selectCategory = (key) => {
  selectedCategory.value = key;
};

watch(selectedCategory, () => {
  currentSlide.value = 0;
});
</script>

<style scoped>
.catalog {
  display: flex;
  flex-direction: column;
  gap: 4.25rem;
}

.nav_catalog {
  display: flex;
  justify-content: space-between;
}

.image-container {
  width: 39.95rem;
}

.slider-frame {
  position: relative;
  overflow: hidden;
  border-radius: 0.6rem;
  background: rgb(245, 242, 238);
}

.category-image {
  width: 39.95rem;
  height: 28rem;
  display: block;
  object-fit: cover;
}

.slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  border: none;
  background: rgba(51, 47, 47, 0.72);
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  padding: 0;
  text-align: center;
}

.slider-arrow:hover {
  background: rgba(245, 160, 62, 0.92);
  transform: translateY(-50%) scale(1.05);
}

.slider-arrow-icon {
  width: 1.15rem;
  height: 1.15rem;
  display: block;
  flex: 0 0 auto;
}

.slider-arrow_prev {
  left: 1rem;
}

.slider-arrow_next {
  right: 1rem;
}

.slider-footer {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.slider-dots {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.slider-dot {
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
  border: none;
  background: rgba(51, 47, 47, 0.18);
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.slider-dot.active {
  background: rgb(245, 160, 62);
  transform: scale(1.15);
}

.slider-counter {
  color: rgb(167, 161, 156);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 0.95rem;
  margin: 0;
}

.section_catalog {
  background: rgb(255, 255, 255);
  width: 100%;
  padding: 6rem 8rem 8rem 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.title_bid_form {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 1.5%;
  text-align: left;
  text-transform: uppercase;
}

.li_button {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
  cursor: pointer;
  padding-bottom: 0.3rem;
  border-bottom: 0.05rem solid transparent;
  transition: 0.2s ease;
}

.li_button.active {
  color: rgb(245, 160, 62);
  border-bottom: 0.05rem solid rgb(51, 47, 47);
  transition: 0.2s ease;
}

.content {
  display: flex;
  gap: 13rem;
}

.title_catalog {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.6rem;
  letter-spacing: 0%;
  text-align: left;
  color: rgb(51, 47, 47);
  margin-bottom: 1rem;
}

.description {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
}

.sub_text_catalog {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}

.box_button_catalog {
  position: absolute;
  bottom: 0;
  left: 0;
}

.button_catalog {
  border-radius: 4rem;
  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  width: 13.35rem;
  height: 3rem;
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.button_catalog::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}

.button_catalog span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}

.selectedCategory_catalog {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}

@media (max-width: 767px) {
  .section_catalog {
    padding: 1.7rem 2.4rem 4rem 2.4rem;
  }

  .nav_catalog {
    gap: 1.5rem;
    row-gap: 0.8rem;
    flex-wrap: wrap;
  }

  .li_button {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
  }

  .image-container {
    width: 100%;
  }

  .category-image {
    width: 100%;
    height: 16rem;
  }

  .content {
    flex-direction: column;
    gap: 1rem;
  }

  .button_catalog {
    position: relative;
    width: 16.5rem;
    height: 2.71rem;
    font-size: 0.71rem;
    font-weight: 700;
    line-height: 0.86rem;
  }

  .catalog {
    gap: 1.5rem;
  }

  .title_bid_form {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }

  .title_catalog {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 2.29rem;
  }

  .description {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    padding-bottom: 5rem;
  }

  .slider-arrow {
    width: 2.2rem;
    height: 2.2rem;
  }

  .slider-arrow-icon {
    width: 1rem;
    height: 1rem;
  }

  .slider-arrow_prev {
    left: 0.6rem;
  }

  .slider-arrow_next {
    right: 0.6rem;
  }

  .slider-footer {
    margin-top: 0.75rem;
  }
}
</style>
